import { UI_HOST_ORIGINS, CT_ORIGIN, EXP_ORIGIN } from "./Host.constants.js";
const isExpUIHostOrigin = () => UI_HOST_ORIGINS.includes(window.location.origin);
const isCTHost = () => CT_ORIGIN === window.location.origin;
const isIFrame = () => {
  return window !== (window == null ? void 0 : window.top);
};
const isSupportedIFrame = () => {
  return isIFrame() && window.location.origin === getTopOrigin();
};
const validateIFrame = () => {
  if (window !== (window == null ? void 0 : window.top) && !isExpIFrame()) {
    window.open(window.location.href, "_top");
    throw new Error("Error trying to load ExPUI in an iFrame, opening in top window");
  }
};
const isExpIFrame = () => {
  return window !== (window == null ? void 0 : window.top) && window.location.origin === EXP_ORIGIN;
};
const isExp = () => {
  return window === (window == null ? void 0 : window.top) && window.location.origin === EXP_ORIGIN;
};
const getTopOrigin = (location = ((_a) => (_a = window == null ? void 0 : window.top) == null ? void 0 : _a.location)()) => {
  try {
    const origin = location.origin;
    return origin;
  } catch (e) {
    return "";
  }
};
const isAuthSupported = () => {
  return window === (window == null ? void 0 : window.top) || window.location.origin === getTopOrigin();
};
export {
  getTopOrigin,
  isAuthSupported,
  isCTHost,
  isExp,
  isExpIFrame,
  isExpUIHostOrigin,
  isIFrame,
  isSupportedIFrame,
  validateIFrame
};
//# sourceMappingURL=Host.utilities.js.map
